import StreamService from "@/services/StreamService";

const defaultState = () => ({
  usage: {},
  isLoading: {},
  isLoaded: {},
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, { type, isLoading }) {
    state.isLoading = { ...state.isLoading, [type]: isLoading };
  },
  SET_USAGE(state, { type, usage }) {
    state.usage = { ...state.usage, [type]: usage };
    state.isLoaded = { ...state.isLoaded, [type]: true };
    state.isLoading = { ...state.isLoading, [type]: false };
  },
  CLEAR_USAGE(state, type) {
    if (type) {
      delete state.usage[type];
      delete state.isLoaded[type];
      delete state.isLoading[type];
    } else {
      state.usage = {};
      state.isLoaded = {};
      state.isLoading = {};
    }
  },
};

function resolvePlatformUsagePayload(payload) {
  if (typeof payload === "string") {
    return { type: payload, force: false };
  }
  return {
    type: payload?.type,
    force: Boolean(payload?.force),
  };
}

const actions = {
  async getPlatformUsage({ commit, state }, typeOrOpts) {
    const { type, force } = resolvePlatformUsagePayload(typeOrOpts);

    if (force) {
      commit("CLEAR_USAGE", type);
    }

    // If already loaded, return from cache
    if (state.isLoaded[type]) {
      return state.usage[type];
    }
    
    // If currently loading, wait for it
    if (state.isLoading[type]) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading[type]) {
            clearInterval(checkLoading);
            resolve(state.usage[type]);
          }
        }, 50);
      });
    }
    
    commit("SET_LOADING", { type, isLoading: true });
    try {
      const usage = await StreamService.getPlatformUsage(type);
      commit("SET_USAGE", { type, usage });
      return usage;
    } catch (error) {
      commit("SET_LOADING", { type, isLoading: false });
      throw error;
    }
  },
  clearPlatformUsage({ commit }, type) {
    commit("CLEAR_USAGE", type);
  },
};

const getters = {
  getUsageByType: (state) => (type) => {
    return state.usage[type] || null;
  },
  isLoaded: (state) => (type) => {
    return state.isLoaded[type] || false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
